import React from 'react';
import AllRoute from '../router'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from '../../theme';


const App = () => {

  return (
    <div className="App" id='scrool'>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AllRoute />
        <ToastContainer />
      </ThemeProvider>
    </div>
  );
}

export default App;
